import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const walletUserDownloadReserve = http.post(
  createMockEndpoint('/wallet_user/download'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
